module.exports = __webpack_public_path__ + "img/B&R_explore_one.364e554e.png";